const eur = new Intl.NumberFormat('sk-SK', { style: 'currency', currency: 'EUR' });
const int = new Intl.NumberFormat('sk-SK');
const dateTime = new Intl.DateTimeFormat('sk-SK', { dateStyle: 'medium', timeStyle: 'short' });
const dateOnly = new Intl.DateTimeFormat('sk-SK', { day: '2-digit', month: 'short' });

export function money(value: number | null | undefined): string {
  return value === null || value === undefined ? '—' : eur.format(value);
}

export function count(value: number | null | undefined): string {
  return value === null || value === undefined ? '—' : int.format(value);
}

export function percent(value: number | null | undefined, digits = 1): string {
  if (value === null || value === undefined) {
    return '—';
  }

  return `${value > 0 ? '+' : ''}${value.toFixed(digits)}%`;
}

export function plainPercent(value: number | null | undefined, digits = 0): string {
  return value === null || value === undefined ? '—' : `${value.toFixed(digits)}%`;
}

export function when(value: string | null | undefined): string {
  return value ? dateTime.format(new Date(value)) : 'never';
}

export function shortDate(value: string): string {
  return dateOnly.format(new Date(value));
}

export function relative(value: string | null | undefined): string {
  if (!value) {
    return 'never';
  }

  const minutes = Math.round((Date.now() - new Date(value).getTime()) / 60000);

  if (minutes < 1) {
    return 'just now';
  }
  if (minutes < 60) {
    return `${minutes} min ago`;
  }
  if (minutes < 1440) {
    return `${Math.round(minutes / 60)} h ago`;
  }

  return `${Math.round(minutes / 1440)} d ago`;
}

/**
 * Recharts wraps an axis label that will not fit its width, and wrapped labels
 * collide with their neighbours. Truncating keeps every tick on one line; the
 * full text belongs in the tooltip.
 */
export function truncate(value: string, max: number): string {
  if (value.length <= max) {
    return value;
  }

  return `${value.slice(0, Math.max(1, max - 1)).trimEnd()}…`;
}

/**
 * Monday 00:00 UTC of the week a timestamp falls in, as an ISO day.
 *
 * Scans land at irregular times, so plotting them as raw categories spaces a
 * three-day gap and a three-week gap identically. Bucketing to the week gives
 * the axis a constant step and puts every scan from one week on one position.
 */
export function weekStart(value: string): string {
  const date = new Date(value);
  const day = date.getUTCDay();
  /* getUTCDay is 0 for Sunday, which belongs to the week that began 6 days earlier. */
  const backToMonday = day === 0 ? 6 : day - 1;

  const monday = new Date(
    Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate() - backToMonday),
  );

  return monday.toISOString().slice(0, 10);
}

/** The ISO day one week after the given one. */
export function nextWeek(isoDay: string): string {
  const date = new Date(`${isoDay}T00:00:00.000Z`);
  date.setUTCDate(date.getUTCDate() + 7);

  return date.toISOString().slice(0, 10);
}
